import React from 'react'
import { Link, useSearchParams } from 'react-router-dom'
import { Bot } from 'lucide-react'

import { ResetPasswordForm } from '../../components/forms/ResetPasswordForm'

export const ResetPasswordPage: React.FC = () => {
  const [searchParams] = useSearchParams()
  const token = searchParams.get('token') || ''

  React.useEffect(() => {
    document.title = 'Reset Password - CleverAct AI'
  }, [])

  return (
    <div className="min-h-screen bg-background flex flex-col justify-center py-12 sm:px-6 lg:px-8">
      <div className="sm:mx-auto sm:w-full sm:max-w-md">
        <Link to="/" className="flex items-center justify-center space-x-2 group">
          <div className="h-10 w-10 rounded-lg bg-gradient-to-br from-primary to-emerald-500 p-[2px]">
            <div className="flex h-full w-full items-center justify-center rounded-[6px] bg-background">
              <Bot className="h-6 w-6 text-primary" />
            </div>
          </div>
          <span className="text-2xl font-bold text-foreground group-hover:text-foreground/80 transition-colors">
            CleverAct AI
          </span>
        </Link>
        <p className="mt-2 text-center text-sm text-muted-foreground">
          Choose a new password
        </p>
      </div>

      <div className="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
        <ResetPasswordForm token={token} className="shadow-lg" />
      </div>
    </div>
  )
}

export default ResetPasswordPage
